/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Switch_DarkInputs */



/**
* | output |
* | --- |
* | "Switch to dark mode" |
*
* @param {Editor_Switch_DarkInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const editor_switch_dark = /** @type {((inputs?: Editor_Switch_DarkInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Switch_DarkInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Zu dunklem Modus wechseln")
	return /** @type {LocalizedString} */ ("Switch to dark mode")
});